import { useMemo } from "react";
import moment from "jalali-moment";
import { CroppingPatternModel } from "@agroyaar/sdk";

interface IntroDesProps {
  croppingPatternReports: CroppingPatternModel;
  createdAt: string;
}

const IntroDes = ({ createdAt, croppingPatternReports }: IntroDesProps) => {
  const thisYear = useMemo(
    () => moment(createdAt).format("jYYYY"),
    [createdAt]
  );

  const nextYear = useMemo(
    () => moment(createdAt).add(1, "year").format("jYYYY"),
    [createdAt]
  );

  return (
    <div className="flex flex-col justify-center items-center">
      <div className="text-xl font-bold">
        <p className="text-[#222] ">
          ارزیابی{" "}
          <span className="text-president ">
            {croppingPatternReports?.selectedCrops.length === 0
              ? croppingPatternReports.cropKind.name === "FARM"
                ? "محصولات زراعی"
                : "محصولات باغی"
              : croppingPatternReports?.reports
                  .map((report) => report.crop.persianName)
                  .join("، ")}
          </span>
        </p>
      </div>
      <div>
        <p className="text-base inline-block text-[#222]"> فصل رشدی: </p>{" "}
        <p className="text-base inline-block">
          {nextYear} - {thisYear}
        </p>
      </div>
    </div>
  );
};

export default IntroDes;
